export function zendesk(element: HTMLScriptElement) {
  element.id = 'ze-snippet';
  const key = import.meta.env.VITE_APP_ZENDESK_TOKEN;
  element.src = `https://static.zdassets.com/ekr/snippet.js?key=${key}`;

  return element;
}
